export const cutWalletPublicId = (id: string) => {
  if (id) {
    return `${id.slice(0, 6)}...${id.slice(-4)}`;
  }
};
